import { render } from "./RemoveIcon.vue?vue&type=template&id=3cb0524c&scoped=true"
import script from "./RemoveIcon.vue?vue&type=script&lang=js"
export * from "./RemoveIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/4109ecccb628e132/monorepo_migration/wijmo-sample/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb0524c"]])

export default __exports__